const publishRequests = {
    list: {
        search: 'ابحث باستخدام اسم الفرع او المكان',
        providerFilterPlaceHolder: 'مقدم الخدمة' ,
        noData:'لا يوجد طلبات نشر حتى الآن',
        home: 'في مكان العميل',
    },
    card: {
        acceptLabel: 'أوافق',
        rejectLabel:'أرفض'
    },
    rejectModal: {
        title:'رفض الطلب',
        contentText:'سبب الرفض',
        placeholder:'ادخل سبب الرفض',
    },
    viewPublishRequest:{
        publishRequests : 'طلبات النشر',
        rejectionFlag:'طلب النشر تم رفضه',
        seeMore:'مشاهدة المزيد'
    }

}

export default publishRequests